import axiosInstance from '@/utils/axiosInstance';

export default async function postClientSecurityOneTimeToken() {
  return (await axiosInstance.post('/client/security/one-time-token')).data
    .oneTimeToken;
}
